export default {
    resetState({commit}) {
        commit('resetStateMutation');
    },
    openForm({commit}) {
        commit('setFormOpen');
    },
    closeForm({commit}) {
        commit('setFormClose');
    },
    openGyseForm({commit}) {
        commit('setGyseFormOpen');
    },
    closeGyseForm({commit}) {
        commit('setGyseFormClose');
    }
}
